import { AppShell } from '../Admin/shell/AppShell';

const TRIM_ADMIN_GROUPS = [
    {
        label: 'Operación',
        items: [
            { path: '/admin-trim/dashboard', label: 'Cotizaciones Trim', icon: 'pi pi-file' },
            { path: '/admin-trim/gestion-usuarios', label: 'Gestión de Usuarios', icon: 'pi pi-users' },
        ],
    },
];

const ROUTE_TITLES = {
    dashboard: 'Dashboard',
    'gestion-usuarios': 'Gestión de usuarios',
};

export const TrimAdminShell = () => (
    <AppShell
        navGroups={TRIM_ADMIN_GROUPS}
        allowedTypes={['3']}
        routeTitles={ROUTE_TITLES}
    />
);

export default TrimAdminShell;
